module.exports = __webpack_public_path__ + "static/media/expand.30984d67.svg";